import Arrow from '@/fsd/pages/plan-fact/ui/icons/arrow';
import { formatMonthYear } from '@/fsd/shared/ui/month-range-picker-with-options/lib/helpers/formatMonthYear/formatMonthYear';
import { IRangeDates } from '@/fsd/shared/ui/month-range-picker-with-options/model/types/IRangeDates';
import cx from 'classnames';
import { Dispatch, SetStateAction } from 'react';
import styles from './MonthRangeFieldInput.module.scss';

interface IProps {
  dates: IRangeDates;
  setShowOptions: Dispatch<SetStateAction<boolean>>;
  disabled?: boolean;
}

const MonthRangeFieldInput = ({ dates, setShowOptions, disabled }: IProps) => {
  return (
    <div
      className={cx(styles.dateInput, disabled ? styles.disabled : undefined)}
      onClick={!disabled ? () => setShowOptions(true) : undefined}
    >
      {dates?.start && dates?.end ? (
        `${formatMonthYear(dates.start)} - ${formatMonthYear(dates.end)}`
      ) : (
        <span className={styles.dateInputSpan}>Выбрать</span>
      )}
      <Arrow className={styles.arrow} />
    </div>
  );
};

export default MonthRangeFieldInput;
